import { elementsToMaxWidth } from '../utils/elemntsToMaxSizes'
import { breakpointUp } from '../utils/breakpoints'

function titleTopPosition()
{
  let title = $('.js-partner-group h4')
  let singleElements = $('.section-partners .partner-item')

  if(singleElements.length) {
    let padding = singleElements.height() / 2 - title.height() / 2
    title.css('margin-top', padding + 'px')
  }

}

elementsToMaxWidth($('.js-partner-group'))

if(breakpointUp('md')) {
  titleTopPosition()
}


